/**
 * Returns the CDN_URL set by the jenkins build. This value will be a string url that ends in '/'.
 * In local environments, this will always return the initial value in the index file (currently '/')
 */
export const domainPrefix = () => window.CDN_URL || '/';
